import supportHero from "../images/support_hero.svg";

export const Support = () => {
  return (
    <>
      <div className="pageHero">
        <div className="pageHeroText">
          <h1 className="pageHeroTitle">Remote Support</h1>
          <p className="pageHeroSubtitle">
            Connect with our support team directly from your browser for fast,
            expert help.
          </p>
        </div>
        <div className="pageHeroImageWrap hide-on-mobile">
          <img src={supportHero} alt="Remote Support" className="pageHeroImg" />
        </div>
      </div>

      <div className="pageContent">
        <div className="serviceSection">
          <iframe
            src="https://techguydom.screenconnect.com/?Theme=Embedded"
            title="Remote Support"
            style={{ width: "100%", height: "800px", border: "none", borderRadius: "6px" }}
          />
        </div>
      </div>
    </>
  );
};
